import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CollageFilterModel} from '../../models/collage-filter.model';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {FilterModelFetchSizeModel} from './models/filter-model-fetch-size.model';

@Component({
  selector: 'app-collage-filter-dialog',
  templateUrl: './collage-filter-dialog.component.html',
  styleUrls: ['./collage-filter-dialog.component.scss']
})
export class CollageFilterDialogComponent implements OnInit {
  isLoading = false;
  filterModel: CollageFilterModel;

  datePickerStart = new Date(2016, 0, 1);
  datePickerEnd = new Date();

  fetchModels: FilterModelFetchSizeModel[] = [];

  constructor(private dialogRef: MatDialogRef<CollageFilterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: CollageFilterModel) {
    this.filterModel = data;
    const all = new FilterModelFetchSizeModel('All', FilterModelFetchSizeModel.ALL);
    const top10 = new FilterModelFetchSizeModel('Top 10', FilterModelFetchSizeModel.TOP_10);
    const top20 = new FilterModelFetchSizeModel('Top 20', FilterModelFetchSizeModel.TOP_20);
    const top50 = new FilterModelFetchSizeModel('Top 50', FilterModelFetchSizeModel.TOP_50);
    this.fetchModels.push(all);
    this.fetchModels.push(top10);
    this.fetchModels.push(top20);
    this.fetchModels.push(top50);
  }

  ngOnInit(): void {
    //
  }

  onStartDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    this.filterModel.startDateMs = event.value.getTime();
  }

  onEndDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    this.filterModel.endDateMs = event.value.getTime();
  }

  getFetchModel() {
    if (this.filterModel) {
      const ret = this.fetchModels.find(p => p.size === this.filterModel.fetchCount);
      if (ret) {
        return ret;
      }
    }
    return null;
  }

  onFetchChange(event: any) {
    this.filterModel.fetchCount = event.value.size;
  }

  onOkClick() {
    localStorage.setItem('collage-filter', JSON.stringify(this.filterModel));
    this.dialogRef.close(this.filterModel);
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
